import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

import { getColorVariable } from './constants'

function IconColoredFaultS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.9598 2.28002C11.1144 1.74982 10.81 1.19466 10.2798 1.04002C9.74958 0.885376 9.19441 1.18982 9.03977 1.72002L5.53977 13.72C5.38513 14.2502 5.68958 14.8054 6.21977 14.96C6.74997 15.1147 7.30513 14.8102 7.45977 14.28L8.84943 9.51548C9.41034 9.53598 9.93537 9.5757 10.421 9.62773C11.2955 9.72141 12.0423 9.855 12.6413 9.98811C13.1885 10.1097 13.612 10.2308 13.8961 10.3206C14.0381 10.3654 14.1452 10.4024 14.2156 10.4276C14.2507 10.4403 14.2767 10.45 14.2932 10.4562L14.3108 10.463L14.314 10.4643C14.5703 10.5664 14.8615 10.4419 14.964 10.1857C15.0665 9.92932 14.9418 9.63834 14.6854 9.53578L14.4997 10C14.6854 9.53578 14.6856 9.53584 14.6854 9.53578L14.684 9.5352L14.6816 9.53425L14.6741 9.53131L14.6482 9.52136C14.6261 9.51297 14.5945 9.50117 14.5534 9.48645C14.4714 9.45701 14.352 9.41587 14.1972 9.36697C13.8876 9.26919 13.436 9.14032 12.8582 9.01192C11.9257 8.8047 10.6635 8.59851 9.13783 8.52668L10.9598 2.28002Z"
        fill={getColorVariable()}
      />
    </svg>
  )
}

export const IconColoredFault = createIcon({
  l: IconColoredFaultS,
  m: IconColoredFaultS,
  s: IconColoredFaultS,
  xs: IconColoredFaultS,
  name: 'IconColoredFault',
})
